"use strict";
/**
 * Created by Marvin on 26.04.17.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.modalReducer = exports.showModal = exports.hideModal = exports.ModalCloseButton = exports.ModalFooter = exports.ModalBody = exports.ModalHeader = exports.Modal = void 0;
var Modal_1 = __importDefault(require("./components/Modal"));
exports.Modal = Modal_1["default"];
var ModalHeader_1 = __importDefault(require("./components/ModalHeader"));
exports.ModalHeader = ModalHeader_1["default"];
var ModalBody_1 = __importDefault(require("./components/ModalBody"));
exports.ModalBody = ModalBody_1["default"];
var ModalFooter_1 = __importDefault(require("./components/ModalFooter"));
exports.ModalFooter = ModalFooter_1["default"];
var ModalCloseButton_1 = __importDefault(require("./components/ModalCloseButton"));
exports.ModalCloseButton = ModalCloseButton_1["default"];
var modalActions_1 = require("./actions/modalActions");
exports.hideModal = modalActions_1.hideModal;
exports.showModal = modalActions_1.showModal;
var modalReducer_1 = __importDefault(require("./reducers/modalReducer"));
exports.modalReducer = modalReducer_1["default"];
exports["default"] = Modal_1["default"];
